export default __webpack_public_path__ + "static/media/tweeter.f37b74a3.svg";